import { useState } from "react";
import { Info } from "lucide-react";

const VatInfoTooltip = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        className="ml-1 text-muted-text hover:text-primary transition-colors align-top"
        aria-label="ÁFA információ"
      >
        <Info size={14} />
      </button>
      
      {isOpen && (
        <div className="absolute z-50 top-full left-1/2 -translate-x-1/2 mt-2 w-72 sm:w-80">
          <div className="bg-ink border border-white/20 rounded-xl p-4 shadow-xl text-left">
            {/* Nyíl felül */}
            <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-ink"></div>
            
            <div className="space-y-3 text-xs text-on-dark/80">
              <div className="flex gap-2">
                <span className="text-accent font-bold">•</span>
                <p>
                  <span className="font-semibold text-on-dark">Magánszemélyek részére</span> a Szolgáltató jogosult alanyi adómentes számla (AAM) kiállítására. Ebben az esetben a feltüntetett árak <span className="text-accent font-medium">bruttó fizetendő összegek</span>.
                </p>
              </div>
              
              <div className="flex gap-2">
                <span className="text-primary font-bold">•</span>
                <p>
                  <span className="font-semibold text-on-dark">Gazdasági társaságok, jogi személyek és áfa-körös vállalkozások részére</span> a feltüntetett árak <span className="text-primary font-medium">nettó áraknak</span> minősülnek, melyekre a mindenkori jogszabály szerinti ÁFA (jelenleg 27%) kerül felszámításra.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VatInfoTooltip;
